export enum FileDestination {
  ACCESSORIES = 'accessories',
  ORDERS = 'orders',
  PROJECT = 'projects',
  OTHER = 'other',
}
